import { resolveVideoEmbedUrl } from '../utils/videoEmbed';
import language from '../variables/language';
import '../css/video-embed.css';

// One shared renderer for every video_embed/VIDEO_EMBED surface (Topic
// builder, Exercise template builder, course-preview, canvas PIN, canvas
// freeform node) - keeps the iframe markup/allow-list and the
// couldn't-embed fallback in exactly one place. `fill` makes the iframe
// fill its parent 100%/100% (the canvas node div already sets explicit
// width/height via its own inline style); without it, uses a responsive
// 16:9 box sized to its container (builder-preview/course-preview context).
export default function VideoEmbedPreview({ url, description, fill, emptyHint }) {
   const lang = language[language.lang];
   if (!url) return <span className='exercise-block-empty-hint'>{emptyHint || lang.videoEmbedEmptyHint}</span>;
   const resolved = resolveVideoEmbedUrl(url);
   return (
      <div className={'video-embed-preview' + (fill ? ' video-embed-preview-fill' : '')}>
         {description ? <p className='video-embed-description'>{description}</p> : ''}
         {resolved ? (
            <div className='video-embed-frame-wrap'>
               <iframe className='video-embed-frame' src={resolved.embedUrl} title={description || resolved.provider}
                  allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                  allowFullScreen />
            </div>
         ) : (
            <div className='video-embed-unrecognized'>
               <p>{lang.videoEmbedUnrecognized}</p>
               <a href={url} target='_blank' rel='noreferrer'>{url}</a>
            </div>
         )}
      </div>
   );
}
